export default "__VITE_ASSET__7dcc85b7__"